import { Component } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';

import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { eventTypeInfoMapV2 } from '../../global.constants';

import { generateUUID } from '../../utilities/state.util';
import { LocationValidationResult } from '../job-helpers';
import { selectJob, selectJobLoading } from '../job-tool.reducer';
import { WorkOrdersActions } from '../job-workorders/job-workorders.actions';

export interface EventTypeMenuItem {
    label: string;
    eventType: string;
    isDisabled: boolean;
    validationTooltip: string | null;
}

function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

@Component({
    selector: 'app-add-event-button',
    standalone: true,
    imports: [
        SharedModule,
        FreyaCommonModule,
    ],
    templateUrl: './add-event-button.component.html',
    styleUrls: ['./add-event-button.component.scss']
})
export class AddEventButtonComponent {

    constructor(
        public store: Store,
    ) { }

    actions = WorkOrdersActions;

    viewModel$ = this.store.select(createSelector(
        selectJob,
        selectJobLoading,
        (job, jobLoading) => {

            const jobClosed = Boolean(job?.closedAt);

            const addableEventTypes: EventTypeMenuItem[] = Object.values(eventTypeInfoMapV2).map((eventTypeInfo) => {
                // Note: removed location validation to allow building estimates before adding locations
                // const validation = job?.locations
                //     ? validateLocationsForEventType(job.locations, eventTypeInfo.value)
                //     : { isValid: false, errorMessage: 'Job not loaded', missingLocations: [], invalidLocations: [] };

                return {
                    label: eventTypeInfo.name,
                    eventType: eventTypeInfo.value,
                    isDisabled: false,
                    validationTooltip: null,
                    // isDisabled: !validation.isValid,
                    // validationTooltip: this._getValidationTooltipText(validation),
                };
            });

            return {
                tooltip: jobClosed && 'Cannot Add Event to Closed Job',
                disabled: jobClosed || jobLoading,
                addableEventTypes,
            }
        }
    ));

    generateEventId = generateUUID;

    _getValidationTooltipText(validation: LocationValidationResult): string | null {
        if (validation.isValid) {
            return null;
        }

        const parts: string[] = [];

        if (validation.missingLocations.length) {
            const locations = validation.missingLocations.map(capitalize).join(', ');
            parts.push(`${locations} missing`);
        }

        if (validation.invalidLocations.length) {
            const locations = validation.invalidLocations.map(capitalize).join(', ');
            parts.push(`${locations} invalid`);
        }

        const action = validation.missingLocations.length ? 'Click to add.' : 'Click to edit.';
        return `${parts.join('; ')}. ${action}`;
    }

}
